import React, { useEffect, useRef, useState } from "react";
import { BsPlus } from "react-icons/bs";

const TeamScalingAnimation = () => {
  const [animate, setAnimate] = useState(false);
  const containerRef = useRef(null);

  const modelsData = {
    dark: {
      gradient: "linear-gradient(135deg, rgba(58,61,64,0.5), rgba(24,24,24,0.2))",
      name: "Alice Johnson",
      role: "CEO",
    },
    green: {
      gradient: "linear-gradient(135deg, rgba(109,212,126,0.5), rgba(76,175,80,0.2))",
      name: "Michael Carter",
      role: "CTO",
    },
    pink: {
      gradient: "linear-gradient(135deg, rgba(255,154,158,0.5), rgba(255,106,136,0.2))",
      name: "Sophia Martinez",
      role: "Designer",
    },
    white: {
      gradient: "linear-gradient(135deg, rgba(224,224,224,0.5), rgba(189,189,189,0.2))",
      name: "Daniel Kim",
      role: "Developer",
    },
    yellow: {
      gradient: "linear-gradient(135deg, rgba(246,211,101,0.5), rgba(253,160,133,0.2))",
      name: "Emily Brown",
      role: "Marketing",
    },
  };

  const entries = [...Object.entries(modelsData), ...Object.entries(modelsData)];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Trigger animation
          setAnimate(false); // reset
          setTimeout(() => setAnimate(true), 50); // restart after a short delay
        }
      },
      { threshold: 0.5 } // adjust how much needs to be visible
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  return (
    <div className="animation_container" ref={containerRef}>
      <div className={`team_container_anim ${animate ? "animate" : ""}`}>
        <div className="scroll_wrapper">
          <div className="scroll_content">
            {entries.map(([key, model], i) => (
              <div key={key + "-" + i} className="team_list_row">
                <div
                  className="team_image_prof_anim"
                  style={{ background: model.gradient }}
                ></div>
                <div className="team_name_prof_anim">
                  <p className="team_name_prof">{model.name}</p>
                  <p className="team_role_prof">{model.role}</p>
                </div>
                <div className="team_icon_prof_anim">
                  <BsPlus />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamScalingAnimation;
